// extracted by mini-css-extract-plugin
module.exports = {"imagePromotionDetail":"modal-max-code-styles_imagePromotionDetail__GwPdg"};